
<div
  role="button"
  tabindex="0"
  class="flex flex-col gap-3 items-start rounded-2xl font-title border border-gray-200 bg-white p-5"
  (click)="goComunnitie()">
    <div class="text-gray-500 text-sm leading-5">
        Comunidad de regantes
    </div>
    <div class="flex justify-space-between items-center text-gray-800 text-title-xs font-bold leading-8 w-full">
        <span class="truncate font-bold">
          {{ community()?.name }}
        </span>
        <ion-icon name="chevron-forward-outline" class="ml-auto"></ion-icon>
    </div>
</div>

